import React from 'react';
import { useResolvedTheme } from '@/hooks/useResolvedTheme';

const LOGO_SRC = {
  dark: '/logo_dark_mode_cropped.png',
  light: '/logo_light_mode_cropped.png',
} as const;

export interface GamutLogoProps {
  alt?: string;
  className?: string;
}

export const GamutLogo: React.FC<GamutLogoProps> = ({
  alt = 'Gamut',
  className = '',
}) => {
  const resolvedTheme = useResolvedTheme();

  return (
    <img
      src={LOGO_SRC[resolvedTheme]}
      alt={alt}
      className={className}
    />
  );
};
